import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

interface BreadCrumbProps {
    title?: string;
    pageTitle?: string;
}

const BreadCrumb = ({ title, pageTitle = 'Inicio' }: BreadCrumbProps) => {
  const location = useLocation();

  // Helper to prettify a URL segment into a human-readable label
  const prettify = (segment: string) =>
    decodeURIComponent(segment)
      .replace(/[-_]+/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());

  // Build dynamic segments from current location
  const rawSegments = location?.pathname?.split('/')?.filter(Boolean) || [];

  const segments = rawSegments.map((seg, idx) => {
    const path = `/${rawSegments.slice(0, idx + 1).join('/')}`;
    return {
      label: prettify(seg),
      path,
      isLast: idx === rawSegments.length - 1,
    };
  });

  // Determine heading/title: prefer prop `title`, else last segment label, else pageTitle
  const heading = title || (segments.length ? segments[segments.length - 1].label : pageTitle);

  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">{heading}</h4>

            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="/">{pageTitle}</Link>
                </li>
                {segments.map((seg, idx) => (
                  seg.isLast ? (
                    <li className="breadcrumb-item active" key={idx}>
                      {title || seg.label}
                    </li>
                  ) : (
                    <li className="breadcrumb-item" key={idx}>
                      <Link to={seg.path}>{seg.label}</Link>
                    </li>
                  )
                ))}
              </ol>
            </div>

          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default BreadCrumb;
